// extracted by mini-css-extract-plugin
export default {"box":"ConfirmModal_box__V24bS","buttons":"ConfirmModal_buttons__uiBve"};